/**
 * Cart Sync - Automatically removes orphaned Extra Card items
 * when their corresponding main product is removed from the cart.
 */
(function () {
  'use strict';

  function syncExtraCards() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var toRemove = [];

        // Build set of main product variant IDs still in cart
        var mainVariants = {};
        cart.items.forEach(function (item) {
          if (!item.properties || item.properties['_locked'] !== 'true') {
            mainVariants[String(item.variant_id)] = true;
          }
        });

        // Find Extra Card items whose main product is no longer in cart
        cart.items.forEach(function (item) {
          if (item.properties && item.properties['_locked'] === 'true') {
            var mainVariant = String(item.properties['_main_variant'] || '');
            if (mainVariant && !mainVariants[mainVariant]) {
              toRemove.push({ line: item.key, quantity: 0 });
            }
          }
        });

        if (toRemove.length === 0) return;

        // Remove orphaned Extra Card items
        var updates = {};
        toRemove.forEach(function (item) {
          updates[item.line] = 0;
        });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      })
      .then(function (updatedCart) {
        if (updatedCart && updatedCart.item_count !== undefined) {
          // Reload page if on cart page, or trigger cart refresh
          if (window.location.pathname.indexOf('/cart') !== -1) {
            window.location.reload();
          } else {
            // Dispatch event for cart drawer to refresh
            window.dispatchEvent(new CustomEvent('cart:synchronized'));
          }
        }
      })
      .catch(function (e) {
        console.error('Cart sync error:', e);
      });
  }

  // Run on page load (for cart page)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncExtraCards);
  } else {
    syncExtraCards();
  }

  // Listen for cart update events (Dawn theme pub/sub)
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(syncExtraCards, 300);
    });
  } else {
    // Fallback: listen for custom events
    document.addEventListener('cart:updated', function () {
      setTimeout(syncExtraCards, 300);
    });
  }
})();
